// src/admin/components/PrivateRoute.jsx
import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useUser } from "../context/AuthContext";

const PrivateRoute = () => {
  const { isLoggedIn } = useUser();

  if (isLoggedIn) {
    return <Outlet />;
  }

  return <Navigate to="/admin/login" replace />;
};

export default PrivateRoute;
